<template>
  <v-container fluid>
    <v-card>
      <PageTitle text="Desempenho por questão">
        <template #suffixTitle>
          <BtnInfo :tooltip-text="STUDENT_QUESTION_METRICS_INFO" />
          <UpdatedAt :date="last_updated_at" />
        </template>
      </PageTitle>
      <v-container fluid>
        <v-row>
          <v-col md="3">
            <v-select
              v-model="subject_id"
              :items="subjects"
              filled
              dense
              item-text="name"
              item-value="id"
              clearable
              class="custom-filter-select w-100"
              placeholder="Filtro: Disciplina"
            />
          </v-col>
          <v-col md="4">
            <SearchFilter
              v-model="search"
              placeholder="Pesquisar por nome do módulo"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-card-text>
        <v-container
          v-for="(cycle,index) of filteredItems"
          :key="index"
          fluid
        >
          <v-row>
            <v-col>
              <p>
                <span class="font-weight-bold">{{ cycle.cycle_name }}:</span> {{ `${$moment(cycle.begin).format('DD [de] MMMM')} até ${$moment(cycle.end).format('DD [de] MMMM')}` }}
              </p>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="cycle.challenge_question"
            hide-default-footer
            style="background-color: #E7E9EF"
            :items-per-page="cycle.show_all ? 30 : 10"
          >
            <template
              v-for="(item) in headers.filter(h => h.tooltip)"
              #[`header.${item.value}`]="{ header }"
            >
              <v-tooltip
                :key="item.value"
                bottom
              >
                <template #activator="{ on }">
                  <span v-on="on">{{ item.text }} <i :class="item.icon" /> </span>
                </template>
                <span>{{ item.tooltip }}</span>
              </v-tooltip>
            </template>
            <template #item.hit="{ item }">
              <i :class="`fas ${item.hit ? 'fa-check-circle text-success': 'fa-times-circle text-danger'}`" />
            </template>
            <template #item.school_grade_rate="{ item }">
              {{ item.school_grade_rate }}%
            </template>

            <template #item.platform_rate="{ item }">
              {{ item.platform_rate }}%
            </template>

            <template #item.access="{ item }">
              <BtnAccess
                tooltip-text="Acessar detalhes"
                @click="question = item"
              />
            </template>

            <template #footer>
              <div class="text-center font-weight-bold p-3">
                Desempenho geral no ciclo: {{ cycle.performance }}%
              </div>
              <div
                v-if="cycle.challenge_question.length"
                class="text-center"
              >
                <v-btn
                  text
                  @click="showAll(cycle, !cycle.show_all)"
                >
                  {{ cycle.show_all ? "Ver menos questões": "Ver todas as questões" }}
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="showModal"
      overlay-color="bg-dark-overlay"
      overlay-opacity="1"
      :width="DEFAULT_DIALOG_WIDTH"
    >
      <template #default>
        <v-card>
          <v-card-title class="d-flex justify-content-between border-bottom">
            Detalhes da questão
            <BtnClose @click="question = null" />
          </v-card-title>
          <PerformancePerQuestionDetails
            v-if="question"
            :question="question"
            :scroll-size="DEFAULT_DIALOG_SCROLL_HEIGHT"
          />
        </v-card>
      </template>
    </v-dialog>
  </v-container>
</template>
<script>
import {mapActions, mapMutations, mapState, mapGetters } from "vuex";
import PageTitle from "@/common/components/PageTitle";
import {DEFAULT_DIALOG_WIDTH,DEFAULT_DIALOG_SCROLL_HEIGHT} from "@/constants/general";
import SearchFilter from "@/school/components/SearchFilter";
import BtnClose from "@/common/components/BtnClose";
import PerformancePerQuestionDetails from "../components/PerformancePerQuestionDetails.vue";
import BtnInfo from '@/common/components/BtnInfo';
import {STUDENT_QUESTION_METRICS_INFO} from "@/constants/messages_info.js";
import BtnAccess from "@/common/components/BtnAccess.vue"
import UpdatedAt from "@/common/components/UpdatedAtComponent"


export default {
  components: {
    BtnAccess,
    BtnInfo,
    PageTitle,
    SearchFilter,
    BtnClose,
    PerformancePerQuestionDetails,
    UpdatedAt,
  },
  props: {},
  data() {
    return {
      showAllQuestionsForCycles: [],
      search:'',
      subject_id:'',
      headers:[
        {text: 'Questão', value: 'id'},
        {text: 'Ordem', value: 'order'},
        {text: 'Módulo', value: 'module_name', width: 500 },
        {text: 'Resposta', value: 'user_answer'},
        {text: 'Desempenho', value: 'hit'},
        { text: 'Desempenho escola', value: 'school_grade_rate', icon: 'fas fa-question-circle', tooltip: "Nota geral da escola considerando o desempenho de todos os alunos de todas as séries da escola" },
        { text: 'Desempenho geral', value: 'platform_rate', icon: 'fas fa-question-circle', tooltip: "Nota geral considerando o desempenho de todos os alunos da plataforma" },
        {text: 'Enunciado', value: 'access', align: 'center'},
      ],
      question: null,
      showModal: false,
      DEFAULT_DIALOG_WIDTH,
      DEFAULT_DIALOG_SCROLL_HEIGHT,
      STUDENT_QUESTION_METRICS_INFO,
    }
  },
  computed:{
    ...mapGetters(["report_logs","subjects", "cycles"]),
    last_updated_at(){
      return this.report_logs.find(r => r.report_table == "challenge_question_rating").last_update
    },
    filteredItems(){
      let cycles = _.cloneDeep(this.cycles);
      return this.subject_id || this.search.length ? cycles.map(c => {
            if(this.search) {
              c.challenge_question = c.challenge_question.filter(q=> q.module_name.toLowerCase().includes(this.search.toLowerCase()));
            }
            if(this.subject_id) {
              c.challenge_question = c.challenge_question.filter(q=>q.subject_id == this.subject_id);
            }
            return c;
          }).filter(c=>c.challenge_question.length)
          : this.cycles;
    }
  },
  watch:{
    question(value){
      this.showModal = !!value;
    },
  },
  created() {
    if(!this.subjects.length){
      this.getSubjects();
    }
  },
  methods: {
    ...mapMutations(['SET_CYCLES']),
    ...mapActions([
      'getSubjects',
      'isLoading'
    ]),
    showAll(cycle, status){
      this.SET_CYCLES(this.cycles.map(c=> {
        c.show_all = c.id == cycle.id ? status : !!c.show_all;
        return c;
      }))
    }
  },
}
</script>
